import React, { useContext } from "react";

import Chart from "react-apexcharts";
import axios from "axios";
import { useState, useEffect } from "react";
import Global from "../../util/Global";
// import { moveFile } from "move-file";
// const moveFile = require("@npmcli/move-file");
// const cpFile = require("cp-file");
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { LoaderComponent } from "../../util/Loader";
import { GlobalData } from "../../util/GlobalData";
import { CurrencyContext } from "../../components/Utils";





const SALES_URL = Global.backend + "/index.php/api/commande/showSales";
const ORDERSURL = Global.backend + "/index.php/api/commande/showOrders";
const userParPays = Global.backend + "/index.php/api/dashboard/userParPays";
const countuser = Global.backend + "/index.php/api/dashboard/nombrentreprise";


const AdminDashboard = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setisLoading] = useState(true);
  const { currency, getCurrencyPrice } = useContext(CurrencyContext)


  const [nombreentreprise, setNombreentreprise] = useState(0);
  const [montantechange, setMontantechange] = useState(0);
  const [donutOptions, setDonutOptions] = useState();
  const [nbUserPerPays, setnbUserPerPays] = useState([])

  const [sales, setsales] = useState([])
  const [orders, setorders] = useState([])


  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  useEffect(() => {
    setpageNavLink({ path: "/dashboard", label: "userDashboard" })
    setpageTitle("adminDashboard")
    setalertTitle("")
    setnavLinks([])
  }, [])


  useEffect(() => {
    setisLoading(true)

    axios.all([
      axios.get(userParPays),
      axios.get(countuser),
      axios.post(SALES_URL),
      axios.post(ORDERSURL)
    ]).then(axios.spread((userPerPaysResponse, usersCountResponse, salesResponse, ordersResponse) => {
      const pays = []

      userPerPaysResponse.data.forEach(val => {
        if (val.pays != "") {
          pays.push(val)
        }
      })

      setnbUserPerPays(pays.map(pays => Number(pays.count)))
      setDonutOptions({ labels: pays.map(pays => pays.pays), chart: { type: "donut", }, responsive: [{ breakpoint: 480, options: { chart: { width: 200, }, legend: { position: "bottom", }, }, },], })
      setNombreentreprise(usersCountResponse.data.count);


      setsales(salesResponse.data)
      setorders(ordersResponse.data)
    })).catch((err) => {

    })
      .finally(() => {
        setisLoading(false)
      })
  }, [])


  useEffect(() => {
    if (isLoading) {
      return
    }

    let totalGain = 0
    sales.map((sale) => {
      if (sale.statut_commande == "paid") {
        totalGain += getCurrencyPrice(sale.totale, sale.currency)
      }
    })
    setMontantechange(totalGain)
  }, [currency, sales])






  return (
    <LoaderComponent isLoading={isLoading}>
      <div className="container-fluid">

        <div className="row">
          <div className="col-xl-8">
            {/*    <div className="card">
                  <div className="card-body">
                    <h4 className="header-title mb-2">Nombre d'entreprise par pays</h4>
                    <div className="row align-items-center">
                      <div className="col-xl-12">
                        <div className="mixed-chart">
                          <Chart
                            options={options}
                            series={series}
                            type="bar"
                            width="630"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
            <div className="card">
              <div className="card-body">
                <h4 className="header-title mb-2">{t("NbusersPerCountry")}</h4>
                <div className="donut d-flex align-items-center justify-content-center">
                  {nbUserPerPays.length && (
                    <Chart
                      options={donutOptions}
                      series={nbUserPerPays}
                      type="donut"
                      width="450"
                    />
                  )}
                  {!nbUserPerPays.length && (
                    <div
                      style={{ height: 150 }}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <h3>{t("noData")}</h3>
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>

          <div className="col-xl-4">
            <div className="row">
              <div className="col-xl-6 col-md-6">
                <div className="card">
                  <div className="card-body">
                    <div className="text-center">
                      <p className="font-size-20">{t("orders")}</p>
                      <div className="mini-stat-icon mx-auto mb-3 mt-3">
                        <span className="avatar-title rounded-circle bg-soft-primary">
                          <i className="mdi mdi-cart-outline font-size-20"></i>
                        </span>
                      </div>
                      <h5 className="font-size-18">{orders.length}</h5>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-6 col-md-6">
                <div className="card">
                  <div className="card-body">
                    <div className="text-center">
                      <p className="font-size-20">{t("registered")}</p>
                      <div className="mini-stat-icon mx-auto mb-3 mt-3">
                        <span className="avatar-title rounded-circle bg-soft-success">
                          <i className="mdi mdi-account-outline font-size-20"></i>
                        </span>
                      </div>
                      <h5 className="font-size-18">{nombreentreprise}</h5>
                    </div>
                  </div>
                </div>
              </div>



              <div className="col-xl-6 col-md-6">
                <div className="card">
                  <div className="card-body">
                    <div className="text-center">
                      <p className="font-size-20">{t("totalSales")}</p>
                      <div className="mini-stat-icon mx-auto mb-3 mt-3">
                        <span className="avatar-title rounded-circle bg-soft-success">
                          <i className="mdi mdi-wallet font-size-20"></i>
                        </span>
                      </div>
                      <h5 className="font-size-18">{GlobalData.currency[currency]} {montantechange.toFixed(2)}</h5>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-6 col-md-6">
                <div className="card">
                  <div className="card-body">
                    <div className="text-center">
                      <p className="font-size-20">{t("deliveredOrders")}</p>
                      <div className="mini-stat-icon mx-auto mb-3 mt-3">
                        <span className="avatar-title rounded-circle bg-soft-primary">
                          <i className="mdi mdi-truck font-size-20"></i>
                        </span>
                      </div>
                      <h5 className="font-size-18">{orders.filter((order) => {
                        var delivered = true
                        order.produitVendus.map((product) => {
                          if (product.statut_livraison != "Livrée") {
                            return delivered = false
                          }
                        })

                        return delivered
                      }).length}</h5>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </LoaderComponent>

  );
};

export default AdminDashboard;
